























import { Component, Prop, Provide, Vue } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import LoginForm from "@/components/authentication/LoginForm.vue";
import RegistrationCta from "@/components/authentication/RegistrationCta.vue";
import UserAlert from "@/components/UserAlert.vue";

@Component({
  components: {
    LoginForm,
    RegistrationCta,
    UserAlert
  }
})
export default class LoginPage extends Vue {}
